"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reportingMessage_1 = require("../reportingMessage");
var linkButton_1 = require("@vidazoo/ui/lib/components/linkButton");
exports.default = (function (_a) {
    var onTryAgainButtonClick = _a.onTryAgainButtonClick;
    return (React.createElement(reportingMessage_1.default, { iconName: "icon-network", title: "Network issue", message: React.createElement("div", { className: "flex justify-center align-baseline" },
            "We have a service error.",
            React.createElement(linkButton_1.LinkButton, { onClick: onTryAgainButtonClick, blue: true, style: { marginLeft: 5 } }, "please try again"),
            ".") }));
});
